import { render, staticRenderFns } from "./LabVitalsTable.vue?vue&type=template&id=64a22a2c&scoped=true&lang=pug"
import script from "./LabVitalsTable.vue?vue&type=script&lang=js"
export * from "./LabVitalsTable.vue?vue&type=script&lang=js"
import style0 from "./LabVitalsTable.vue?vue&type=style&index=0&id=64a22a2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a22a2c",
  null
  
)

export default component.exports